export const alumniColumnDefs = [
    {
        field: "registration_id",
        headerName: "Registration ID",
        cellRendererParams: {
            color: '#e7b100'
        },
        cellRenderer: (data) => {
            return `A${String(data.value).padStart(4, '0')}`;
        },
    },
    {
        field: "full_name",
        cellStyle: { fontWeight: 'bold' },
        headerName: "Full Name"
    },
    {
        field: "passed_out_year.year_name",
        headerName: "Passed Out Year"
    },
    {
        field: "college.college_name",
        headerName: "College"
    },
    {
        field: "attendance_status.description",
        headerName: "Attendance Status"
    },
    {
        field: "created_at",
        headerName: "Created At"
    },
    {
        field: "updated_at",
        headerName: "Updated At"
    },
    {
        field: "contact_number",
        headerName: "Phone Number"
    },
    {
        field: "stream.stream_name",
        headerName: "Stream"
    },
    {
        field: "email",
        headerName: "Email"
    },

    {
        field: "accompany_count",
        headerName: "Acc Count"
    },
    {
        field: "ticket_status.description",
        headerName: "Ticket Status"
    }
]
